import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}`;
